export default __webpack_public_path__ + "static/media/downDropIcon.494a4e1b.png";